<div *ngIf="count > 0" class="circle">{{ count }}</div>
<rx-icon name="icon-copy-2"></rx-icon>
